// extracted by mini-css-extract-plugin
export default {"rating":"kN-z","numberOfStars":"lN-z","count":"mN-z","barGraphSpacing":"nN-z","barGraph":"oN-z"};